import { render, staticRenderFns } from "./jddsh.vue?vue&type=template&id=0e2e604d&scoped=true&"
import script from "./jddsh.vue?vue&type=script&lang=js&"
export * from "./jddsh.vue?vue&type=script&lang=js&"
import style0 from "./jddsh.vue?vue&type=style&index=0&id=0e2e604d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2e604d",
  null
  
)

export default component.exports